<style lang="scss" scoped>
    .intel-sort{
        height: 20px;
        // margin-left: 20px;
        margin-left: 24px;
        &.sortnull{
            width: 84px;
        }
        &.sort1{
            width: 141px;
        }
        &.sort2{
            width: 141px;
        }

        /deep/ .el-input__inner {
            border: none;
            background: none;
            box-shadow: none;
            color: rgb(79, 122, 253);
            font-size: 14px;
        }
        /deep/ .el-input.is-focus .el-input__inner{
            border: none;
            background: none;
            box-shadow:none;
        }

        /deep/ .el-input__suffix {
            i {
                display: none;
            }
        }

        /deep/ .el-input{
            height: 20px;
            line-height: 20px;
            display: flex;
            align-items: center;
            
            input{
                // padding-left: 26px;
                flex: 1;
                height: 100%;
                padding: 0;
                margin-left: 6px;
                line-height: 20px;
            }
            &::before{
                content: ' ';
                display: block;
                width: 20px;
                height: 20px;
                background-image: url('~@/assets/newicons/sort01.png');
                background-size: cover;
                background-position: center;
            }
        }
    }
</style>
<template>
    <el-select :class="['intel-sort', 'sort'+value]" v-model="sortValue" @change="sortChange()">
        <el-option v-for="item in optionsTime" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: null,
        sortData: {
            type: Array,
            default: () => {
                return [
                    // {
                    //     value: null,
                    //     label: '智能排序'
                    // },
                    {
                        value: 1,
                        label: '成立时间'
                    }, 
                    {
                        value: 2,
                        label: '最新ICP时间'
                    }
                ]
            }
        }
    },
    mounted() {

        this.optionsTime = this.sortData
        this.sortValue = this.value   
    },
    data() {
        return {
            sortValue: null,
            optionsTime: null,
        }
    },
    methods: {
        sortChange() {
            this.$emit('sortChange', this.sortValue)
        }
    }
}
</script>